import { type FlowSkillsFindAllQueryParams } from 'flow-schema';

import type { Common } from '../common.js';
import { type FlowWithCreatedBy } from '../models/flow/flow.js';
import { type SkillDefinitionWithSkill } from '../models/flow/flowDefinition.js';

export class API {
  common: Common;
  baseEndpoint = '/flow/block';

  constructor(common: Common) {
    this.common = common;
  }

  async findAllSkills(queryParams?: FlowSkillsFindAllQueryParams): Promise<FlowWithCreatedBy[]> {
    const url = this.common.constructPath(`${this.baseEndpoint}/skills`, queryParams);
    return await this.common.getJSON(url);
  }

  async findOneSkillById(skillId: string): Promise<SkillDefinitionWithSkill> {
    const url = this.common.constructPath(`${this.baseEndpoint}/skills/${skillId}`);
    return await this.common.getJSON(url);
  }
}
